// @ts-nocheck
import React from 'react'
import * as R from 'ramda'

import { DetailsCard } from 'components/shared/DetailsCard/DetailsCard'

export const CompetencyDescription = ({ competencies }) =>
  R.map(
    ({ label, explanation }) => (
      <React.Fragment key={label}>
        <DetailsCard.Subtitle>{label}</DetailsCard.Subtitle>
        <DetailsCard.Text>{explanation[0]}</DetailsCard.Text>
      </React.Fragment>
    ),
    competencies,
  )
